export default {
    'diagram5-3a1': {
        'diagram-number': '5.',
        'elements': {
            'one': 'Many different areas of the brain must work together to perform music',
            'two': 'Active participation in music may stimulate development of those areas',
            'three': 'The implication for early education in the arts is clear',
        }
    }
}


// WEBPACK FOOTER //
// ./client/app/components/diagrams/3/3a1/diagram5/i18n/en.js